module.exports = __webpack_public_path__ + "img/delar-confirm.2e5c2b8e.png";